import { api } from "../../api/api";
import { store } from "../../redux/storeConfig/store";
import {
  addAppointmentModal,
  addFollowupProgramModal,
  addGateModal,
  addPackageModal,
  addSaleModal,
  addStaffModal,
  addTrainerModal,
  addUserModal,
  addWodModal,
  setRetailModal,
} from "../../redux/actions/sidebar/sidebarAction";
import {
  getAllMembers,
  getTrainerAttribute,
} from "../../redux/actions/api/apiAction";
import { setOpenLeadModal } from "../../redux/actions/lead/leadAction";
import { setVoiceAdd } from "../../redux/reducers/voiceAdd/voiceAddReducer";
import { formPropsFromDraft } from "./contracts";
import { setRFIDCardIdValue } from "../../redux/actions/membershipCard/membershipCardAction";

const gymId = () => {
  const login = JSON.parse(
    localStorage.getItem("connectToFitGymPanelUser") || "{}"
  );
  return login.gym;
};

let latestOpenRequest = 0;

export const cancelPendingDraftForm = () => {
  latestOpenRequest += 1;
};

export async function openDraftForm(draft, extras) {
  const requestId = ++latestOpenRequest;
  // Keep Add with Voice mounted behind the existing form. Closing or cancelling
  // the form returns the admin to the same review state.
  store.dispatch(setVoiceAdd({ prefill: draft }));

  switch (draft.type) {
    case "member": {
      const card =
        (draft.fields &&
          (draft.fields.RFIDCardIdField || draft.fields.cardMembershipId)) ||
        "";
      if (card) store.dispatch(setRFIDCardIdValue(card));
      store.dispatch(addUserModal(true));
      return true;
    }
    case "lead":
      store.dispatch(setOpenLeadModal(true));
      return true;
    case "package":
      store.dispatch(addPackageModal(true, false, {}));
      return true;
    case "sale":
      store.dispatch(addSaleModal(true, false, {}));
      return true;
    case "product":
      store.dispatch(setRetailModal(true, false, {}));
      return true;
    case "class":
      if (extras.openClass) extras.openClass();
      return Boolean(extras.openClass);
    case "workshop":
      if (extras.openWorkshop) extras.openWorkshop();
      return Boolean(extras.openWorkshop);
    case "court":
      if (extras.openCourt) extras.openCourt();
      return Boolean(extras.openCourt);
    case "instructor":
      store.dispatch(addTrainerModal(true));
      store.dispatch(getTrainerAttribute());
      return true;
    case "appointment":
      store.dispatch(addAppointmentModal(true));
      return true;
    case "staff": {
      store.dispatch(addStaffModal(true, false, {}));
      api("permission?type=STAFF", {}, "get")
        .then((res) => {
          if (requestId !== latestOpenRequest) return;
          const permissions =
            res && res.status !== 400 ? res.data.data || [] : [];
          if (extras.onStaffPermissions) extras.onStaffPermissions(permissions);
        })
        .catch(() => {
          if (requestId !== latestOpenRequest) return;
          if (extras.onStaffPermissions) extras.onStaffPermissions([]);
        });
      return true;
    }
    case "workout":
      store.dispatch(addWodModal(true));
      store.dispatch(getAllMembers(gymId()));
      return true;
    case "followup":
      store.dispatch(addFollowupProgramModal(true));
      return true;
    case "gate":
      store.dispatch(addGateModal(true));
      store.dispatch(getAllMembers(gymId()));
      return true;
    default:
      return false;
  }
}

export function lookupItems(value) {
  if (!value) return [];
  const list = Array.isArray(value) ? value : [value];
  return list.filter(
    (item) => item && (item.id || item.pending || item.value)
  );
}

export function voicePackageRow(pack, drafts = []) {
  const pendingId = pack && (pack.pending || pack.id || pack.value);
  const draft = (drafts || []).find(
    (item) => item && item.id === pendingId && item.type === "package"
  );
  const fields = (draft && draft.fields) || {};
  const session =
    fields.session && String(fields.session) !== "unlimited"
      ? Number(fields.session)
      : pack && pack.sessionCount
      ? pack.sessionCount
      : pack && pack.count
      ? pack.count
      : 1;
  return {
    id: (pack && pack.id) || pendingId,
    pending: pack && pack.pending,
    name: fields.title || (pack && (pack.name || pack.label)) || "",
    label: fields.title || (pack && (pack.name || pack.label)) || "",
    price: fields.price || (pack && pack.price) || 0,
    sessionCount: session,
    count: (pack && pack.count) || 1,
    planType: fields.memberShipType || (pack && pack.planType) || "",
    duration: fields.days || (pack && pack.duration),
    durationType: fields.duration || (pack && pack.durationType),
    appointments: (pack && pack.appointments) || [],
    requiredAttachment: Boolean(pack && pack.requiredAttachment),
  };
}

export function memberFormProps(prefill) {
  return formPropsFromDraft(prefill, "member");
}

export function packageFormProps(prefill) {
  return formPropsFromDraft(prefill, "package");
}

export function draftFormProps(prefill, type) {
  return formPropsFromDraft(prefill, type);
}

export function pickerDate(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === "string" && value.trim()) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  return null;
}

const PICKER_DATE_KEYS = ["startDate", "endDate", "date"];
const PICKER_DATE_TYPES = { class: true, workshop: true };

export function withVoicePrefill(type, defaults) {
  const extras = formPropsFromDraft(
    store.getState().voiceAdd && store.getState().voiceAdd.prefill,
    type
  );
  const next = { ...(defaults || {}) };
  Object.keys(extras || {}).forEach((key) => {
    if (extras[key] === undefined || extras[key] === null) return;
    if (
      extras[key] === "" &&
      next[key] !== undefined &&
      next[key] !== ""
    ) {
      return;
    }
    next[key] = extras[key];
  });
  if (PICKER_DATE_TYPES[type]) {
    PICKER_DATE_KEYS.forEach((key) => {
      if (next[key] === undefined || next[key] === null || next[key] === "") return;
      const date = pickerDate(next[key]);
      if (date) next[key] = date;
      else delete next[key];
    });
  }
  return next;
}
